import { CommonData } from "../../datastructures/gamestate/gameData";

export interface IGameElement<T extends CommonData> {
     new (activeGameData: T, parent: PIXI.Container) : GameElement<T>;
}

export class GameElement<T extends CommonData> {

    protected activeGameData: T;
    protected parent: PIXI.Container;
    
    constructor (activeGameData: T, parent: PIXI.Container){
        this.activeGameData = activeGameData;
        this.parent = parent;
    }
}